import { z } from 'zod';
import { StepDecisionRuleSchema } from '../../entities/process-step-recording';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { PositionSchema } from '../../shared/position.schema';
/**
 * Appended to the source's rules; M's edge binds to this rule's output group
 * instead of `ruleId`'s. The client mints `_id` (it builds the row from the
 * decision-table columns).
 */ export const DraftBranchAppendedRuleSchema = StepDecisionRuleSchema.extend({
    _id: ObjectIdSchema
});
/**
 * POST /api/v2/process/:id/draft/steps/branch — request
 *
 * Transactionally add a new task step M wired to one existing node: after a
 * source step ("open parallel branch") or before a target ("merge parallel
 * branch"). Existing edges are left alone. **Id space: stableStepIds
 * throughout** (draft steps and draft assignments share it).
 *
 * No `.refine`/`.superRefine` (bliksy resolveSubSchema); cross-field rules
 * are enforced service-side as 400s:
 * - `after` needs a step source (not an assignment). A decision source needs
 *   `ruleId` or `appendedRule`; a task source must not have `ruleId`.
 * - `appendedRule` needs a decision source, and its `_id` must not already
 *   be a rule of the source nor equal `ruleId`.
 */ export const DraftBranchAnchorSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('after'),
        sourceStableStepId: ObjectIdSchema,
        /** The clicked handle. Without `appendedRule`, its ended marker clears. */ ruleId: ObjectIdSchema.optional(),
        appendedRule: DraftBranchAppendedRuleSchema.optional()
    }),
    z.object({
        kind: z.literal('before'),
        targetStableStepId: ObjectIdSchema
    })
]);
export const AddDraftBranchStepRequestSchema = z.object({
    anchor: DraftBranchAnchorSchema,
    position: PositionSchema,
    laneKey: z.string().optional()
});

//# sourceMappingURL=add-draft-branch-step.schema.js.map